import { Dispatch } from 'redux';
import api from './api'; // Assuming 'api' is exported from a module at this path

// Action Types
const GET_TIMESLOTS = 'GET_TIMESLOTS';
const GET_TIMESLOTS_SUCCESS = 'GET_TIMESLOTS_SUCCESS';
const GET_TIMESLOTS_FAILURE = 'GET_TIMESLOTS_FAILURE';

// Action Interfaces
interface GetTimeSlotsAction {
  type: typeof GET_TIMESLOTS;
}

interface GetTimeSlotsSuccessAction {
  type: typeof GET_TIMESLOTS_SUCCESS;
  payload: TimeSlot[];
}

interface GetTimeSlotsFailureAction {
  type: typeof GET_TIMESLOTS_FAILURE;
  error: string;
}

// Union of Action Types
type TimeSlotActionTypes = GetTimeSlotsAction | GetTimeSlotsSuccessAction | GetTimeSlotsFailureAction;

// Define the structure of a TimeSlot
interface TimeSlot {
  uuid: string;
  name: string;
  start: string;
  end: string;
  createdAt: string;
  updatedAt: string;
}

// Define the structure of the TimeSlot state
interface TimeSlotState {
  loading: boolean;
  timeSlots: TimeSlot[];
  error: string | null;
}

// Initial state for the TimeSlot reducer
const initialState: TimeSlotState = {
  loading: false,
  timeSlots: [],
  error: null,
};

// Reducer
const timeslotReducer = (
  state: TimeSlotState = initialState,
  action: TimeSlotActionTypes
): TimeSlotState => {
  switch (action.type) {
    case GET_TIMESLOTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_TIMESLOTS_SUCCESS:
      return {
        ...state,
        loading: false,
        timeSlots: action.payload,
        error: null,
      };
    case GET_TIMESLOTS_FAILURE:
      return {
        ...state,
        loading: false,
        timeSlots: [],
        error: action.error,
      };
    default:
      return state;
  }
};

// Async Action Creator to fetch TimeSlots
export const getTimeSlots = () => async (dispatch: Dispatch<TimeSlotActionTypes>) => {
  dispatch({ type: GET_TIMESLOTS });
  try {
    const response = await api.get('/api/timeslots');
    dispatch({
      type: GET_TIMESLOTS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GET_TIMESLOTS_FAILURE,
      error: (error as Error).message,
    });
  }
};

export default timeslotReducer;
